import { jsxs, jsx } from 'react/jsx-runtime';
import { Navbar, Link } from '@sketch/components';
import '../../routes/index.js';
import { Header, LogoWrapper } from './IndexLayout.styles.js';
import { routes } from '../../routes/routes.js';

const IndexLayoutHeader = ({ noBorder, disableLogoLink, children, }) => (jsxs(Header, Object.assign({ noBorder: noBorder }, { children: [jsx(LogoWrapper, Object.assign({ "data-testid": "sketch-logo" }, { children: disableLogoLink ? (jsx(Navbar.Logo, { variant: "black" })) : (jsx(Link, Object.assign({ to: routes.ENTRY.create({}) }, { children: jsx(Navbar.Logo, { variant: "black" }) }))) })), jsx(Navbar.Section, Object.assign({ align: "start" }, { children: children }))] })));

export { IndexLayoutHeader };
